<template>
  <div>
    <label>Send Mail Description</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        :style="`${
          selectedMailDescription != '' && selectedMailDescription != null
            ? 'border-right:0px'
            : 'border-radius:5px'
        }`"
        name="mail-description-id"
        autocomplete="off"
        placeholder="Mail Description"
        @input="updateMailDescription()"
        @change="updateMailDescription()"
        list="mail-description-list"
        id="mail-description-id"
        v-model="selectedMailDescription"
      />
      <datalist id="mail-description-list">
        <option
          :value="item.name"
          :data-id="item.id"
          v-for="item in store.custom.mailDescriptionList"
          :key="item"
        >
          {{ item.name }}
        </option>
      </datalist>
      <button
        @click="selectedMailDescription = ''"
        v-if="selectedMailDescription != null && selectedNotification != ''"
        class="btn"
        style="
          border-left: 0px;
          border-top: 1px #dee2e6 solid;
          border-right: 1px #dee2e6 solid;
          border-bottom: 1px solid #dee2e6;
          color: #0000008a;
        "
        type="button"
      >
        <i class="fas fa-xmark"></i>
      </button>
    </div>
    <div v-if="displaySelectedDescription != null" class="d-flex flex-column py-4">
      <span v-if="displaySelectedDescription.message != null"
        >Description: <em>{{ displaySelectedDescription.message }}</em></span
      >
      <div style="border-top: 1px solid #0000000f; margin-block: 0.5rem"></div>
      <div class="d-flex flex-column fs-6">
        <span class="fs-5">Rewards:</span>
        <div
          class="container"
          v-for="key of Object.keys(displaySelectedDescription.reward)"
          :key="key"
        >
          <div v-if="key == 'equipments'" class="container">
            <span class="fw-bold">{{ formatKey(key) }}</span>
            <div
              class="row col-8"
              v-for="item of displaySelectedDescription.reward[key]"
              :key="item"
            >
              <div class="col-10">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ getEquipmentName(item.equipment_id)
                }}{{ item.isExpiration ? "()" : "" }}
              </div>
              <div class="col-2 text-end">{{ item.equipmentCount }}</div>
            </div>
          </div>
          <div
            class="container"
            v-else-if="key == 'exp' && displaySelectedDescription.reward[key] != 0"
          >
            <div class="row col-8">
              <div class="col-10 fw-bold">{{ formatKey(key) }}</div>
              <div class="col-2 text-end">
                {{ displaySelectedDescription.reward[key] }}
              </div>
            </div>
          </div>
          <div
            class="container"
            v-else-if="key == 'gold' && displaySelectedDescription.reward[key] != 0"
          >
            <div class="row col-8">
              <div class="col-10 fw-bold">{{ formatKey(key) }}</div>
              <div class="col-2 text-end">
                {{ displaySelectedDescription.reward[key] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-end gap-2 pt-3 pb-1 mt-5"
      style="border-top: 1px #00000022 solid"
    >
      <button type="button" class="btn btn-success" @click="sendRewards">Send</button>
      <button type="button" class="btn btn-secondary" @click="emit('close')">Close</button>
    </div>
  </div>
</template>

<script setup>
import {defineEmits, defineProps, ref } from "vue";
import store from "node-back-client/src/store";
import ToastService from "toast/src/services/toast";
import ModalService from "modal/src/services/Modal";

const selectedMailDescription = ref(null);
const selectedMainDescId = ref(null);
const displaySelectedDescription = ref(null);

const emit = defineEmits(['close'])

const props = defineProps({
  data: {
    entity: Object,
    show: Boolean,
  },
  api: { type: Object },
});

const sendRewards = () => {
  const id = this.data.entity._id;
  if (!selectedMailDescription.value) {
    ToastService.Notify({
      title: "Failed",
      message: "Please select Mail Description",
    });
    return;
  }
  ModalService.Show(
    {
      title: `Send Reward  via Mail`,
      message: `Do you want to send ${selectedMailDescription.value}?`,
    },
    async () => {
      const res = await props.api.charlist.sendRewardsviaMail(id, selectedMainDescId.value, 1);
      if (res.message === "Failed") {
        ToastService.Notify({
          title: "Error",
          message: "Unable to save.",
        });
      } else {
        ToastService.Notify({
          title: "Success",
          message: `'${selectedMailDescription.value}' successfully sent!`,
        });
      }
    }
  );
};
const updateMailDescription = () => {
  const selectedOption = document.querySelector(
    `#mail-description-list option[value='${selectedMailDescription.value}']`
  );
  if (selectedOption) {
    selectedMainDescId.value = parseInt(selectedOption.getAttribute("data-id"));
  }
  displaySelectedDescription.value = store.custom.mailDescriptionList.find(
    (x) => x.id == selectedMainDescId.value
  );
};
const formatKey = (key) => {
  return key.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str.toUpperCase();
  });
};
const getEquipmentName = (id) => {
  return store.custom.equipmentList.find((x) => x.id == id).name;
};
</script>

